import React, { FC } from 'react'
import { Link } from '@material-ui/core'
import { Link as GatsbyLink } from 'gatsby'

import StylesModule from 'components/lv2/topicPath.module.scss'

export interface TopicPathProps {
  top: string
  name: string
}

const TopicPath: FC<TopicPathProps> = ({ top, name }) => {
  return (
    <section className={StylesModule.topicPath}>
      <Link component={GatsbyLink} to="../../index.html">
        {top}
      </Link>{' '}
      / {name}
    </section>
  )
}

export default TopicPath
